export default "__VITE_ASSET__B5l13Q9A__"